import React, { forwardRef } from 'react';
import { Menu as MenuNew } from './Menu';
import { convertOldMenuProps } from './converter.old';
import type { OldMenuProps } from './converter.old';

export type MenuProps = OldMenuProps;

export const Menu = forwardRef<HTMLUListElement, MenuProps>((props, ref) => (
  <MenuNew {...convertOldMenuProps(props)} ref={ref} />
));
